/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* RunInvoicingRequest
*/
export class V1RunInvoicingRequest {
    /**
    * The date to run invoicing for
    */
    'runDate'?: string;
    /**
    * Whether to run invoicing in dry run mode
    */
    'dryRun'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "runDate",
            "baseName": "run_date",
            "type": "string",
            "format": ""
        },
        {
            "name": "dryRun",
            "baseName": "dry_run",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1RunInvoicingRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

